"use client";
import {
  useComboboxStore
} from "../__chunks/ZKJ2WLF7.js";
import {
  ComboboxContextProvider
} from "../__chunks/W76OTZCC.js";
import "../__chunks/7GBW5FLS.js";
import "../__chunks/Y6GYTNQ2.js";
import "../__chunks/IB7YUKH5.js";
import "../__chunks/4UUKJZ4V.js";
import "../__chunks/7H5KSHHF.js";
import "../__chunks/G6BJYYBK.js";
import "../__chunks/OAYFXAQ2.js";
import "../__chunks/3ORBWXWF.js";
import "../__chunks/MG4P3223.js";
import "../__chunks/ZSELSBRM.js";
import "../__chunks/SFCBA2JZ.js";
import "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/combobox/combobox-provider.tsx
import { jsx } from "react/jsx-runtime";
function ComboboxProvider(props = {}) {
  const store = useComboboxStore(props);
  return /* @__PURE__ */ jsx(ComboboxContextProvider, { value: store, children: props.children });
}
export {
  ComboboxProvider
};
